import React from 'react';
import { Info } from 'lucide-react';
import type { ReputationImageStyle } from '@reach/shared-types/automation-template';
import {
  DESCRIBE_STEP_HEADING,
  IMAGE_STYLE_FIELD_LABEL,
  IMAGE_STYLE_OPTIONS,
  IMAGE_TOGGLE_HELP,
  IMAGE_TOGGLE_LABEL,
  MAX_VERTICAL_DESCRIPTION_LENGTH,
  ONE_SHOT_WARNING,
  SKIP_EXPLANATION,
  VERTICAL_FIELD_HELP,
  VERTICAL_FIELD_LABEL,
  VERTICAL_FIELD_PLACEHOLDER,
} from './reputation-defaults.constants';
import styles from './reputation-defaults-dialog.module.css';

interface DescribeVerticalStepProps {
  verticalDescription: string;
  onVerticalDescriptionChange: (value: string) => void;
  includeImages: boolean;
  onIncludeImagesChange: (value: boolean) => void;
  imageStyle: ReputationImageStyle;
  onImageStyleChange: (value: ReputationImageStyle) => void;
  disabled: boolean;
}

export const DescribeVerticalStep: React.FC<DescribeVerticalStepProps> = ({
  verticalDescription,
  onVerticalDescriptionChange,
  includeImages,
  onIncludeImagesChange,
  imageStyle,
  onImageStyleChange,
  disabled,
}) => (
  <section className={styles.describeStep}>
    <h4 className={styles.stepHeading}>{DESCRIBE_STEP_HEADING}</h4>

    <label className={styles.fieldLabel} htmlFor="reputation-vertical">
      {VERTICAL_FIELD_LABEL}
    </label>
    <textarea
      id="reputation-vertical"
      className={styles.textarea}
      value={verticalDescription}
      maxLength={MAX_VERTICAL_DESCRIPTION_LENGTH}
      placeholder={VERTICAL_FIELD_PLACEHOLDER}
      disabled={disabled}
      onChange={event => onVerticalDescriptionChange(event.target.value)}
    />
    <p className={styles.fieldHelp}>{VERTICAL_FIELD_HELP}</p>

    <label className={styles.toggleRow}>
      <input
        type="checkbox"
        checked={includeImages}
        disabled={disabled}
        onChange={event => onIncludeImagesChange(event.target.checked)}
      />
      {IMAGE_TOGGLE_LABEL}
    </label>
    <p className={styles.fieldHelp}>{IMAGE_TOGGLE_HELP}</p>

    {includeImages && (
      <>
        <label className={styles.fieldLabel} htmlFor="reputation-image-style">
          {IMAGE_STYLE_FIELD_LABEL}
        </label>
        <select
          id="reputation-image-style"
          className={styles.select}
          value={imageStyle}
          disabled={disabled}
          onChange={event => onImageStyleChange(event.target.value as ReputationImageStyle)}>
          {IMAGE_STYLE_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </>
    )}

    <p className={styles.oneShotNotice}>
      <Info size={14} />
      {ONE_SHOT_WARNING}
    </p>
    <p className={styles.skipExplanation}>{SKIP_EXPLANATION}</p>
  </section>
);
